import { mainSiteUrl } from '@/mocks/categories';

export default function FullscreenCTA() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20bright%20workspace%20with%20laptop%20displaying%20colorful%20spreadsheet%20charts%2C%20shopping%20bags%20and%20coffee%20on%20light%20oak%20desk%2C%20soft%20natural%20window%20light%2C%20warm%20inviting%20atmosphere%2C%20clean%20contemporary%20office%20aesthetic&width=1920&height=1080&seq=cta-bg-new&orientation=landscape"
          alt="Yoybuy Spreadsheet"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 text-center px-6 max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white tracking-wide whitespace-nowrap">
          YOYBUY SPREADSHEET
        </h2>
        <p className="mt-4 text-base md:text-lg text-white/80 font-light leading-relaxed max-w-xl mx-auto">
          Умный способ покупать товары из Китая
          <br />
          без риска и переплат
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-0 px-1 py-1 pl-6 bg-foreground-950 text-white rounded-full hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center -ml-3">
              <i className="ri-shopping-bag-3-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
            <span className="ml-3 text-sm font-semibold uppercase tracking-wide whitespace-nowrap">Yoybuy Sheet</span>
            <i className="ri-arrow-right-up-line text-white ml-3 mr-4 text-base w-4 h-4 flex items-center justify-center"></i>
          </a>

          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-foreground-950 text-sm font-semibold rounded-full hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
          >
            <span>BUY IT NOW</span>
            <i className="ri-arrow-right-up-line text-base w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}